// TODO IMPLEMENT - THIS IS JUST A STUB
import { action, observable } from "mobx"
import store from "store"
import { observer } from "mobx-react";
// import _ from "lodash"
const STORE_KEY = "bshop::orderlists"

export default class OrderlistStore {
  constructor( api ) {
    this.api = api
  }
  
  setup() {
    let currentListId = store.get( `${STORE_KEY}-listId` )
    let list = this.lists[ currentListId ]
    if ( list ) {
      this.setCurrentList( list )
    }
  }
  
  @observable lists = []
  @observable ids = []
  @observable byId = new Map()
  @observable deliveryAddress = false
  @observable invoiceAddress = false
  @observable baseAddress = false
  
  @observable isOpenSelectionModel = false
  @observable currentProduct = false
  @observable currentListId = false
  @observable currentList = false
  
  @action
  toggleSelectionModal = ( product ) => {
    this.isOpenSelectionModel = !this.isOpenSelectionModel
    if ( product && this.isOpenSelectionModel ) {
      this.currentProduct = product
    }
  }
  
  @action
  setCurrentList( list ) {
    //console.log( `list TEST`, list )
    this.currentList = list
    if ( list ) {
      this.currentListId = list.title
    } else {
      this.currentListId = false
    }
    
    store.set( `${STORE_KEY}-listId`, list.title )
  }
  
  @action
  create( { title } ) {
    let list = this.byId.get( title )
    if ( !list ) {
      list = new List( { title } )
      this.lists.push( list )
      this.ids.push( title )
      this.byId.set( title, list )
    }
  }
  
  save() {
    store.set( STORE_KEY, this.ids )
    //console.log("STORE_KEY + ", STORE_KEY, " this.ids ", this.ids)
  }
  
  restore() {
    let ids = store.get( STORE_KEY )
    console.log( `ORDERLIST::ids`, ids )
  }
  
}

export class List {
  constructor( api ) {
    this.api = api
  }
  
  @observable positions = []
  @observable byId = new Map()
  @observable items = false
  @observable size = false
  @observable value = false
  
  @action fetch() {
    fetch( `${this.api.config.API}/data/customers/current/addresses/deliver`, {
      credentials: "include"
    } )
      .then( res => res.json() )
      .then( locations => {
        console.log( `locations`, locations )
        if ( locations.length < 1 ) {
          console.info( "Keine Versandadressen vorhanden" )
          return
        }
        
        this.deliveryAddress = locations[ 0 ]
        this.invoiceAddress = locations[ 0 ]
        this.baseAddress = locations[ 0 ]
        
        this.list = locations
        this.list.forEach( loc => {
          console.log( `location`, loc )
          this.byId.set( loc.mapid, loc )
        } )
      } )
  }
}





// WEBPACK FOOTER //
// ./src/sdk/store/OrderlistStore.js